import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AffiliateComponent} from './affiliate.component';
import {routing} from "./affiliate.routing";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {RouterModule} from "@angular/router";
import {DialogModule} from "primeng/dialog";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ComponentsModule} from "../features/components/components.module";
import {CarouselModule} from "primeng/carousel";
import {TagModule} from "primeng/tag";
import {ButtonModule} from "primeng/button";
import {MenuModule} from "primeng/menu";
import {BadgeModule} from "primeng/badge";
import {GalleriaModule} from "primeng/galleria";
import {ProfileModule} from "../features/profile/profile.module";
import {ChipModule} from "primeng/chip";
import {ChipsModule} from "primeng/chips";
import {FieldsetModule} from "primeng/fieldset";
import {SidebarModule} from "primeng/sidebar";
import {AccordionModule} from "primeng/accordion";
import {ProductsModule} from "../features/product/products.module";
import {CoreModule} from "../core/core.module";
import {MomentModule} from "ngx-moment";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {ProgressBarModule} from "primeng/progressbar";
import {DashboardComponent} from "./dashboard/dashboard.component";
import {EarningComponent} from "./earning/earning.component";
import {LinksComponent} from "./links/links.component";
import {ProductsComponent} from "./products/products.component";
import {RatingModule} from "primeng/rating";
import {CardModule} from "primeng/card";
import {TabMenuModule} from "primeng/tabmenu";
import {DropdownModule} from "primeng/dropdown";
import {SignUpComponent} from "./sign-up/sign-up.component";
import {UserKycComponent} from "./user-kyc/user-kyc.component";
import {ToastModule} from "primeng/toast";
import {FileUploadModule} from "primeng/fileupload";
import {MessageService} from "primeng/api";
import {ReferralComponent} from "./referral/referral.component";
import {TableModule} from "primeng/table";
import {HeaderComponent} from "./common/header/header.component";

@NgModule({
  declarations: [
    AffiliateComponent,
    DashboardComponent,
    EarningComponent,
    LinksComponent,
    ProductsComponent,
    SignUpComponent,
    UserKycComponent,
    ReferralComponent,
    HeaderComponent,
  ],
  exports: [],
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    routing,
    RouterModule,
    DialogModule,
    FormsModule,
    ComponentsModule,
    CarouselModule,
    TagModule,
    ButtonModule,
    MenuModule,
    BadgeModule,
    GalleriaModule,
    ProfileModule,
    ChipModule,
    ChipsModule,
    FieldsetModule,
    SidebarModule,
    AccordionModule,
    ProductsModule,
    CoreModule,
    MomentModule,
    ProgressSpinnerModule,
    ReactiveFormsModule,
    ProgressBarModule,
    RatingModule,
    CardModule,
    TabMenuModule,
    DropdownModule,
    ToastModule,
    FileUploadModule,
    TableModule,

  ],
  providers: [MessageService]
})
export class AffiliateModule {
}
